export default __webpack_public_path__ + "static/media/holly_Nicework.0672fd62.mp3";